import { isNetworkError } from "@/shared/errors";

/**
 * Why a submission failed, said for the person who pressed the submit.
 *
 * `network` is the browser failing to reach Roboto at all, whose own wording
 * ("Failed to fetch") names nothing a person can act on. `rejected` is
 * everything else, where the server's reason is the most useful thing to show.
 */
export interface SubmitError {
  kind: "network" | "rejected";
  message: string;
}

const NETWORK_MESSAGES: Record<"create" | "edit", string> = {
  create:
    "Couldn't reach Roboto to create this trigger. Check your network connection, then try again.",
  edit: "Couldn't reach Roboto to save your changes. Check your network connection, then try again.",
};

const FALLBACK_MESSAGES: Record<"create" | "edit", string> = {
  create: "Something went wrong creating this trigger.",
  edit: "Something went wrong saving this trigger.",
};

export function submitError(
  error: unknown,
  mode: "create" | "edit",
): SubmitError {
  if (isNetworkError(error)) {
    return { kind: "network", message: NETWORK_MESSAGES[mode] };
  }
  return {
    kind: "rejected",
    message:
      error instanceof Error && error.message.length > 0
        ? error.message
        : FALLBACK_MESSAGES[mode],
  };
}
